import {
  DraftDeleteOutcome,
  QuestionnaireDraftScopedRequest,
} from "../../lib/questionnaire_draft/coordinator";
import {
  questionnaireDraftRequestData,
  runQuestionnaireDraftRequest,
} from "./questionnaire_draft_request";

// Deletes the identity's recovery copy. The server answers 204 whether or not one was there.
export function* sendQuestionnaireDraftDelete({
  scope,
  key,
}: QuestionnaireDraftScopedRequest): Generator<any, DraftDeleteOutcome, any> {
  const result = yield* runQuestionnaireDraftRequest({
    scope,
    path: "/v1/web/questionnaire-draft-delete",
    data: questionnaireDraftRequestData(key),
  });
  if (result.kind === "ok") return { kind: "deleted" };
  if (result.kind === "rate_limited") return { kind: "retry" };
  return result;
}
